import { createContext, useMemo, useContext } from "react";
import { __DEV__ } from "@thebouqs/utils";
import { useId } from "@thebouqs/hooks";
export var DropdownMenuContext = /*#__PURE__*/createContext({
  value: false,
  setValue: () => {}
});

if (__DEV__) {
  DropdownMenuContext.displayName = "DropdownMenuContext";
}

export function useDropdownMenuContext() {
  var dropdownMenuCtx = useContext(DropdownMenuContext);

  if (!dropdownMenuCtx) {
    throw new Error("[useDropdownMenuContext]: ensure DropdownMenu is higher in the hierarchy of the element you want to call this function in");
  }

  return dropdownMenuCtx;
}
/**
 *
 * @param id - it's the id of the popper's reference element
 */

export function useDropdownMenuPopoverReference(referenceId) {
  var id = useId(referenceId);
  var result = useMemo(() => {
    return {
      popoverReferenceProps: {
        id
      },
      menuProps: {
        modifiers: [{
          name: "popperOffset",
          enabled: true,
          phase: "read",
          fn: _ref => {
            var {
              state
            } = _ref;
            var popperReference = document.getElementById(id);

            if (popperReference) {
              state.elements.reference = popperReference;
            } else {
              console.error("[useMultiDropdownButton] cannot find any DOM element with id: " + id);
            }
          }
        }]
      }
    };
  }, [id]);
  return result;
}
//# sourceMappingURL=use-dropdownmenu-menu.js.map